var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('client-only',[(_vm.isDefaultVariation)?_c('span',[_vm._t("default")],2):_vm._e(),(!_vm.isDefaultVariation)?_c('span',[_vm._t(_vm.activeVariation)],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }